const Artdata = [{
    id : "1",
    schemeName: "I.	Centenaries and Anniversaries Scheme",
    discription:"To commemorate of centenary and special anniversaries such as 125th/150th/175th etc. of eminent personalities and events of historical importance to the country. The commemoration starts of completion of 100/125/150 etc. years and continue for a period of one year.",
    launchDate: "write",
    AnualFund: "12345"

},
{id : "2",
schemeName: "Kala Sanskriti Vikas Yojana.",
discription:"To promote and disseminate the art & culture of the country by providing financial support to drama, theatre groups, dance groups, music ensembles, folk theatre & music and other genres of performing art activities.",
launchDate: " year 2013",
AnualFund: "12345"},


{id : "3",
schemeName: "Development of Libraries & Archives",
discription:"National Mission on Libraries (NML) has an objective of establishing a National Virtual Library of India, establishment of Model Libraries, quantitative/ qualitative survey of Libraries and capacity building. All National, State and district level libraries are to be developed as model libraries, with emphasis on developing these libraries in economically backward districts. Further, district libraries across the states would be provided network connectivity.",
launchDate: "write",
AnualFund: "12345"},

{
id : "4",
    schemeName: "Global Engagement and International Co-operation",
    discription:"Promote Indian Cultural abroad. Strengthen bonds of foreign countries with India.",
    launchDate: "write",
    AnualFund: "12345"
},
{ id : "5",
schemeName: "V.	National Mission on Manuscripts",
discription:"Document each and every manuscript and manuscript repository, for a National Electronic Database that currently contains information on four million manuscripts making this the largest database on Indian manuscripts in the world.",
launchDate: "write", 
 AnualFund: "12345"},


{   id : "6",
schemeName: "Development of Museum",
discription:"Digitization of art objects in the museums across the country for making their images/catalogues available over the website",
launchDate: "write",
AnualFund: "12345"
},
{   id : "7",
schemeName: "Seva Bhoj Yojana.",
discription:"Seva Bhoj Yojna’ is a Central Sector Scheme of the Ministry of Culture, Government of India.",
launchDate: "1 August 2018",
AnualFund: "12345"},


{   id : "8",
schemeName: "Project Mausam",
discription:"Project ‘Mausam’ is a Ministry of Culture project to be implemented by Indira Gandhi National Centre for the Arts (IGNCA), New Delhi as the nodal coordinating agency with support of Archeological Survey of India and National Museum as associate bodies.",
launchDate: "20 June 2014",
AnualFund: "12345"},


{   id : "9",
schemeName: "Scheme For Pension And Medical Aid to Artistes",
discription:"‘A pension scheme by MoC improving the financial and socio-economic status of the old artists and scholars who have contributed significantly in their specialized fields, but due to old age they have to lead a miserable life or are in penury condition",
launchDate: " 3 January 2018",
AnualFund: "12345"},



]
export default Artdata;